// Layout
import NonScLayout from './NonscLayout'
import NonScTemplate from './pages/NonScTemplate'

// Project Pages
import NonScProjectEditor from './pages/project/NonScProjectEditor'
import NonScProjectList from './pages/project/NonScProjectList'
import NonScProjectHome from './pages/project/NonScProjectHome'

// Import Pages
import NonScImportHome from './pages/project-import/NonScImportHome'

// Home Pages
import NonScHomeList from './pages/home/NonScHomeList'
import NonScHomeDetail from './pages/home/NonScHomeDetail'

// User Pages
import NonScUserList from './pages/user/NonScUserList'
import NonScUserDetail from './pages/user/NonScUserDetail'

/** @type {RouteConfig} */
export default {
  path: 'nonsc',
  component: NonScLayout,
  children: [
    {
      path: '/',
      redirect: {
        name: 'nonsc-project'
      }
    },
    {
      path: 'project',
      name: 'nonsc-project',
      component: NonScTemplate,
      redirect: {
        name: 'nonsc-project-list'
      },
      children: [
        {
          path: 'list',
          name: 'nonsc-project-list',
          component: NonScProjectList
        },
        {
          path: 'create',
          name: 'nonsc-project-create',
          component: NonScProjectEditor,
        },
        {
          path: 'update/:projectId?',
          name: 'nonsc-project-update',
          component: NonScProjectEditor
        },
        {
          path: ':projectId/home',
          name: 'nonsc-project-home',
          component: NonScProjectHome
        },
        {
          path: ':projectId/home/import',
          name: 'nonsc-project-home-import',
          component: NonScImportHome
        },
        {
          path: ':projectId/home/:homeId',
          name: 'nonsc-project-home-detail',
          component: NonScHomeDetail
        }
      ]
    },
    {
      path: 'home',
      name: 'nonsc-home',
      component: NonScTemplate,
      redirect: {
        name: 'nonsc-home-list'
      },
      children: [
        {
          path: 'list',
          name: 'nonsc-home-list',
          component: NonScHomeList
        },
        {
          path: ':homeId',
          name: 'nonsc-home-detail',
          component: NonScHomeDetail
        },
      ]
    },
    {
      path: 'user',
      name: 'nonsc-user',
      component: NonScTemplate,
      redirect: {
        name: 'nonsc-user-list'
      },
      children: [
        {
          path: 'list',
          name: 'nonsc-user-list',
          component: NonScUserList
        },
        {
          path: ':userId',
          name: 'nonsc-user-detail',
          component: NonScUserDetail
        },
      ]
    }
  ]
}